module.exports = __webpack_public_path__ + "img/BICE.aa17075.png";